<template>
    <div id="size">
        <div class="pubw">
            <el-form :model="orderBoxes" :rules="orderBoxesFormRule" ref="orderBoxesForm">
                <div class="top">
                    <div class="h">
                        <div class="left">
                            <span>郵件尺寸 ( 厘米 )</span>
                        </div>
                        <div class="right">
                            <span>郵件重量（公斤）</span>
                            <span>數量</span>
                        </div>
                    </div>
                    <div class="b">
                        <div class="left">
                            <div class="head">
                                <span class="el-icon-s-opportunity"></span>
                                <span>不確定尺寸和重量？別擔心！</span>
                            </div>
                            <div class="body">
                                <span>快遞公司接收寄件後會再確定運費，並會於快遞完成後3星期追收或退回差額。</span>
                            </div>
                        </div>
                        <div class="right">
                            <div class="head">
                                <span class="el-icon-s-opportunity"></span>
                                <span>尺寸計算</span>
                            </div>
                            <div class="body">
                                <span>尺寸用作計算體積重量，體積越大收費越高。</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bottom">
                    <div class="form">
                        <div class="left">
                                <div class="t">
                                    <el-form-item>
                                        <el-input onkeyup="value=value.replace(/[^\d]/g,'')" v-model="orderBoxes.longBox"></el-input>
                                    </el-form-item>
                                    <div class="x">
                                        <span>x</span>
                                    </div>
                                    <el-form-item>
                                    <el-input   onkeyup="value=value.replace(/[^\d]/g,'')" v-model="orderBoxes.widthBox"></el-input>
                                    </el-form-item>
                                    <div class="x">
                                        <span>x</span>
                                    </div>
                                    <el-form-item>
                                    <el-input  onkeyup="value=value.replace(/[^\d]/g,'')"  v-model="orderBoxes.highBox"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="b">
                                    <el-form-item prop="longBox">
                                    <el-input disabled placeholder="長"></el-input>
                                    </el-form-item>
                                    <div class="x">
                                        <span>x</span>
                                    </div>
                                    <el-form-item prop="widthBox">
                                        <el-input   disabled placeholder="闊"></el-input>
                                    </el-form-item>
                                    <div class="x">
                                        <span>x</span>
                                    </div>
                                    <el-form-item prop="highBox">
                                        <el-input  disabled placeholder="高"></el-input>
                                    </el-form-item>
                                </div>
                        </div>
                        <div class="right">
                            <div class="weight">
                                <div class="t">
                                    <el-form-item>
                                        <el-input onkeyup="value=value.replace(/[^\d]/g,'')" v-model="orderBoxes.volume"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="b">
                                    <el-form-item prop="volume">
                                        <el-input  disabled placeholder="每件重量"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="count">
                                <count :kg="orderBoxes.volume" :callback="incrementNumAndDecrementNum" :count="orderBoxes.count"/>
                                <count :kg="orderBoxes.volume" :callback="incrementNumAndDecrementNum" :count="0" :isDisabled="true"/>
                                <div class="operration">
                                    <div class="clearAll" @click="clearAll">
                                        <span class="el-icon-delete-solid"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="add">
                        <div class="c" @click="add">
                            <span class="el-icon-circle-plus icon"></span>
                            <span>增加数量</span>
                        </div>
                    </div>
                    <div class="shipmentDate" v-if="boxType==4">
                        <div class="h">備註出貨日期</div>
                        <el-form :model="shipmentDateForm" :rules="shipmentDateFormrules" ref="ruleForm" class="shipmentDateForm">
                            <el-date-picker
                                @change="setDate"
                                v-model="shipmentDate"
                                type="datetime"
                                :picker-options="pickerOptions"
                                placeholder="選擇日期">
                            </el-date-picker>
                        </el-form>
                    </div>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
// 引人组件
import Count from '@/components/Count.vue'
import {mapState,mapMutations} from 'vuex'
import {nanoid} from "nanoid"
import formatDate from "@/assets/js/actionDate.js"
export default {
    mame:'Size',
    props:["boxType"],
    components:{
        Count
    },
    data() {
        return {
            // 面积表单规则
            orderBoxesFormRule:{
                widthBox:[
                    {required:true,message:'* 必需填寫。',trigger:'blur'}
                ],
                highBox:[
                    {required:true,message:'* 必需填寫。',trigger:'blur'}
                ],
                longBox:[
                    {required:true,message:'* 必需填寫。',trigger:'blur'}
                ],
                count:[
                    {required:true,message:'* 必需填寫。',trigger:'blur'}
                ],
                volume:[
                    {required:true,message:'* 必需填寫。',trigger:'blur'}
                ],
            },       
            "orderBoxes":{
                "boxType":this.boxType,
                "boxid": 0,
                // 数量
                "count": 0,
                // 高
                "highBox": "",
                // 长
                "longBox": "",
                "orderId": 0,
                // 体积重量
                "volume": "",
                // 宽
                "widthBox": ""
            },
            // 出货日期表单
            shipmentDateForm:{},
            // 用户选择的出货日期
            shipmentDate:"",
            // 出货日期表单规则
            shipmentDateFormrules:{

            },
            // 禁用日期
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now() + (2*60*60) - 8.64e7;
                },
            }
        }
    },
    methods: {
        ...mapMutations(["UPDATEWEIGHT","ADDORDERBOX"]),
        // 监听用户点击清除表单
        clearAll(){
            this.$refs.orderBoxesForm.resetFields()
            this.orderBoxes.count = 0
        },
        // 用户修改日期时间
        setDate(date){
            const opt = formatDate(date)
            console.log(opt)
            if(false) return this.message.error("仅能选择两小时后的时间")
            this.$store.commit('SETORDERREMARKS',date)
        },
        // 用户点击添加数量
        incrementNumAndDecrementNum(type){
            // 判断用户点击的是加还是减
            if(type){
                if( this.orderBoxes.count>=99) return
                this.orderBoxes.count++
            }else{
                if(this.orderBoxes.count<=1) return
                this.orderBoxes.count--
            }
        },
        // 用户点击增加数量
        add(){
            this.$refs.orderBoxesForm.validate(valid => {
                if(!valid) return 
                this.orderBoxes.id = nanoid()
                if(this.orderBoxes.count <= 0 ) return this.$message.error("请输入添加数量")
                this.ADDORDERBOX(JSON.parse(JSON.stringify(this.orderBoxes)))
                this.$refs.orderBoxesForm.resetFields()
                this.orderBoxes.count = 0
            })
        }
    }
}
</script>

<style lang="less" scoped>
 #size{
     margin-top: 50px;
    .top{
        justify-content: center;
        .h{
            display: flex;
            font-size: 17px;
            font-weight: 550;
            .left,
            .right{
                width: 50%;
            }
            .left{
                margin-right: 130px;
            }
            .right{
                span{
                    margin-right: 150px;
                }
            }
        }
        .b{
            display: flex;
            align-items: center;
            width: 100%;
            height: 75px;
            background-color: #f1efff;
            border-radius: 10px;
            margin-top: 30px;
            padding: 30px 10px;
            .left,
            .right{
                display: flex;
                flex-wrap: wrap;
                width: 50%;
                div{
                    width: 100%;
                    span{
                        margin:8px 0;
                    }
                }
                .head{
                    margin-bottom: 5px;
                }
                .head span:first-child{
                    color: #ffe108;
                }
            }
            .left{
                display: flex;
                margin-right: 130px;
            }
        }
    }
    .bottom{
        margin-top: 30px;
        .form{
            display: flex;
            .left,.right{
                width: 50%;
            }
            .el-form{
                display: flex;
                flex-wrap: wrap;
            }
            .left{
                margin-right: 135px;
                .t{
                    display: flex;
                    align-items: center;
                    .el-form{
                        display: flex;

                        .el-input__inner{
                            height: 56px !important;
                        }
                    }
                }
                .b{
                    display: flex;
                    .el-form-item .el-input__inner{
                        text-align: center;
                    }
                }
                .t,.b {
                    .x{
                        display: flex;
                        align-items: center;
                        padding-bottom: 22px;
                        margin:0 5px;
                        font-size:20px;
                        font-weight:540;
                    }
                }
            }
            .right{
                position: relative;
                display: flex;
                .weight{
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    .el-form{
                        display: flex;
                        flex-wrap: wrap;
                        width: 180px;
                        .el-input__inner{
                            width: 170px !important;
                        }
                    }
                }
                .count{
                    line-height: 50px;
                   .count{
                     margin-bottom: 22px;
                   }
                }
                .operration{
                    position: absolute;
                    right: 0px;
                    top: 12px;
                    .clearAll{
                        span{
                            font-size: 30px;
                            color:#F7320F;
                        }
                        &:hover{
                            cursor: pointer;
                            opacity: .8;
                        }
                    }
                }
            }
        }
        .add{
            text-align: center;
            .c{
                width: 100px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin:0 auto;
                &:hover{
                    cursor: pointer;
                    opacity: .8;
                }
            }
            span{
                color: @colorMain;
                font-size:17px;
            }
            .icon{
                font-size: 30px;
            }
        }
        .shipmentDate{
            .h{
                display: flex;
                font-size: 17px;
                font-weight: 550;
                margin-bottom:20px;
            }
            .shipmentDateForm{
                .el-date-editor{
                    .el-input__inner{
                        height: 56px;
                    }
                }
            }
        }
    }
 }
 
/* 最大宽度768px 手机 */
@media screen and (max-width: 768px){

}
</style>